// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ARTICLE_IS_DRAFT = "(Tento \u010dl\u00e1nek je aktu\u00e1ln\u011b rozepsan\u00fd)";
export const ARTICLE_TEXT = "Zn\u011bn\u00ed \u010dl\u00e1nku";
export const ARTICLE_TITLE = "Nadpis \u010dl\u00e1nku";
export const CHANGE_ARTICLE = "Uprav \u010dl\u00e1nek";
export const HOWTO_DETAILS = "Z\u00e1kladn\u00ed \u00fadaje n\u00e1vodu";
export const HOWTO_EDIT_STEPS = "Uprav postup n\u00e1vodu";
export const HOWTO_IS_DRAFT = "(Tento n\u00e1vod je aktu\u00e1ln\u011b rozepsan\u00fd, ne publikovan\u00fd)";
export const HOWTO_TEXT = "Kroky n\u00e1vodu";
export const HOWTO_TITLE = "Nadpis n\u00e1vodu";
export const RECIPE_DETAILS = "Z\u00e1kladn\u00ed \u00fadaje receptu";
export const RECIPE_EDIT_DETAILS = "Uprav z\u00e1kladn\u00ed \u00fadaje";
export const RECIPE_EDIT_STEPS = "Uprav postup p\u0159\u00edpravy";
export const RECIPE_IS_DRAFT = "(Tento recept je aktu\u00e1ln\u011b rozepsan\u00fd, ne publikovan\u00fd)";
export const RECIPE_TEXT = "Postup p\u0159\u00edpravy";
export const RECIPE_TITLE = "Nadpis receptu";
export const TAB_BLOGS_ALL = "V\u0161echny";
export const TAB_BLOGS_POPULAR = "Popul\u00e1rn\u00ed";
export const TAB_BLOGS_SUBSCRIBED = "Odeb\u00edr\u00e1m";
